export const removeIllegalChars = (text: string): string => {
  if (text) {
    return text.replace(/([^\d a-zäåö]+)/gi, '');
  }

  return text;
};
